import { render, staticRenderFns } from "./InvoiceReject.vue?vue&type=template&id=6a520a33&"
import script from "./InvoiceReject.vue?vue&type=script&lang=js&"
export * from "./InvoiceReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports